import { render, staticRenderFns } from "./TargetAndRewardRow.vue?vue&type=template&id=29dda0dc&scoped=true&"
import script from "./TargetAndRewardRow.vue?vue&type=script&lang=js&"
export * from "./TargetAndRewardRow.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndRewardRow.vue?vue&type=style&index=0&id=29dda0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dda0dc",
  null
  
)

export default component.exports